import type { FunctionComponent } from "react";
import { Input } from "@App/Components/common/Input";
import { useTranslation } from "react-i18next";

type AddressFormProps = {
  onSubmit?: () => void;
  street: {
    required: boolean;
    value: string;
    validationMessage?: string;
    disabled?: boolean;
    onChange: (street: string) => void;
  };
  city: {
    required: boolean;
    value: string;
    validationMessage?: string;
    disabled?: boolean;
    onChange: (city: string) => void;
  };
  postcode: {
    required: boolean;
    value: string;
    validationMessage?: string;
    disabled?: boolean;
    onChange: (postcode: string) => void;
  };
  addition: {
    required: boolean;
    value: string;
    validationMessage?: string;
    disabled?: boolean;
    onChange: (addition: string) => void;
  };
};

export const AddressForm: FunctionComponent<AddressFormProps> = ({
  street,
  city,
  postcode,
  addition,
  onSubmit,
}: AddressFormProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Input
        id={"street"}
        name="street"
        className={"w-full"}
        placeholder={t("contactForm.placeholders.street")}
        value={street.value}
        onChange={street.onChange}
        validationMessage={street.validationMessage}
        required={street.required}
        disabled={street.disabled ?? false}
      />
      <Input
        id={"additional"}
        name="additional"
        className={"w-full"}
        placeholder={t("contactForm.placeholders.addition")}
        value={addition.value}
        onChange={addition.onChange}
        validationMessage={addition.validationMessage}
        required={addition.required}
        disabled={addition.disabled ?? false}
      />
      <Input
        id={"postcode"}
        name="postcode"
        className={"w-full"}
        placeholder={t("contactForm.placeholders.postcode")}
        value={postcode.value}
        onChange={postcode.onChange}
        validationMessage={postcode.validationMessage}
        required={postcode.required}
        disabled={postcode.disabled ?? false}
      />
      <Input
        id={"city"}
        name="city"
        className={"w-full"}
        placeholder={t("contactForm.placeholders.city")}
        value={city.value}
        onChange={city.onChange}
        validationMessage={city.validationMessage}
        required={city.required}
        disabled={city.disabled ?? false}
        onSubmit={onSubmit}
      />
    </>
  );
};
